import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Checkbox, Input, List, Modal } from 'antd';
import { sortableElement, sortableContainer, arrayMove } from 'react-sortable-hoc';
import { DV3CloseIcon, DV3DragIcon, DV3SearchIcon } from '../common/icons';

const SortableItem = sortableElement(({ column, onRemove, value }) => {
	return <li>
		<div className='text-part'>
			<DV3DragIcon />
			<span>{column?.title || '-'}</span>
		</div>
		<button
			type={'button'}
			className='sorter-close-button'
			onClick={() => {
				if (typeof (onRemove) === 'function')
					onRemove(value);
			}}>
			<DV3CloseIcon />
		</button>
	</li>
});

const SortableContainer = sortableContainer(({ children }) => {
	return <ul className='sortable-list-hoc'>{children}</ul>;
});

class CustomColumns extends Component {

	state = {
		_visibleColumns: [],
		_visible: false,
		columnSearch: null,
	}

	componentDidMount() {
		const { visibleColumns, visible } = this.props;
		this.setState({ _visibleColumns: visibleColumns || [], _visible: !!visible, _columnChanged: false });
	}

	componentDidUpdate() {
		const { _visible } = this.state;
		const { visibleColumns, visible } = this.props;

		if (!_visible && !!visible) {
			this.setState({ _visibleColumns: visibleColumns || [], _visible: !!visible, columnSearch: null })
		}
	}

	render() {
		const { visible, title, onCancel, modalProps, columnsSet, intl } = this.props;
		const { columnSearch, _columnChanged, _visibleColumns } = this.state;
		
		const additionalProps = {...(modalProps || {})}
		const titleText = title || <FormattedMessage id='table.customizeTitle' defaultMessage='Custom columns' />;
		const columnsSelectorSource = (columnsSet || []).filter(x => !x.hidden);

		return <Modal
			visible={visible}
			className='filter-modal table-customize'
			footer={null}
			width={800}
			closeIcon={<DV3CloseIcon />}
			onCancel={onCancel}
			{...additionalProps}>

			<div className='header'>
				<div className='title'>
					<span>{titleText}</span>
				</div>
			</div>

			<div className='table-customize'>
				<div className='table-customize-left'>
					<div className='table-customize-titles'>
						<div>
							<span className='title'><FormattedMessage id='table.customizeTitle.titleleft' defaultMessage='Columns' /></span>
							<span className='v3-web-tag'>{columnsSelectorSource?.length}</span>
						</div>
						<span className='sub-title'><FormattedMessage id='table.customizeTitle.subtitleleft' defaultMessage='Select columns to show in the table' /></span>
					</div>

					<div className='filters-area'>
						<Input
							value={columnSearch}
							onChange={({ target: { value } }) => this.setState({ columnSearch: value })}
							placeholder={intl.formatMessage({ id: 'driver.table.search', defaultMessage: 'Search' })}
							addonAfter={<DV3SearchIcon />} />
					</div>

					<div className='table-customize-list-area'>
						<List
							dataSource={columnsSelectorSource?.filter(x => !columnSearch || x.title.toLowerCase().includes(columnSearch))}
							renderItem={(item) => {
								return <List.Item>
									<Checkbox
										onChange={() => {
											let { _visibleColumns } = this.state;
											_visibleColumns = _visibleColumns.indexOf(item.dataIndex) >= 0 ?
                                                                _visibleColumns.filter(x => x !== item.dataIndex) :
                                                                [..._visibleColumns, item.dataIndex];
											this.setState({ _visibleColumns, _columnChanged: true });
										}}
										checked={_visibleColumns?.indexOf(item.dataIndex) >= 0}
										value={_visibleColumns?.indexOf(item.dataIndex) >= 0}>{item.title}</Checkbox>
								</List.Item>
							}}
						/>
					</div>
				</div>
				<div className='table-customize-right'>
					<div className='table-customize-titles'>
						<div>
							<span className='title'><FormattedMessage id='table.customizeTitle.titleright' defaultMessage='Columnas seleccionadas' /></span>
							<span className='v3-web-tag'>{_visibleColumns?.length}</span>
						</div>
						<span className='sub-title'><FormattedMessage id='table.customizeTitle.subtitleright' defaultMessage='You can order the columns as you wish.' /></span>
					</div>
					<div className='table-customize-list-area'>
						<SortableContainer
							distance={1}
							helperClass='helper-class'
							onSortEnd={({ oldIndex, newIndex }) => {
								let { _visibleColumns } = this.state;
								_visibleColumns = arrayMove(_visibleColumns, oldIndex, newIndex)
								this.setState({ _visibleColumns, _columnChanged: true });
							}}>
							{
								(_visibleColumns || []).map((value, index) => {
									const column = columnsSet?.find(x => x.dataIndex === value);
									return <SortableItem
										key={`item-${value}`}
										index={index}
										value={value}
										column={column}
										onRemove={(v) => {
											let { _visibleColumns } = this.state;
											_visibleColumns = _visibleColumns.filter(x => x !== v);
											this.setState({ _visibleColumns, _columnChanged: true });
										}}
									/>
								})
							}
						</SortableContainer>
					</div>
				</div>
			</div>

			<div className='buttons'>
				<div className='buttons-group'>
					<button
						type={'button'}
						className='v3-button secondary'
						onClick={onCancel}>
						<FormattedMessage id='cancel' defaultMessage='Cancel' />
					</button>

					<button
						type={'button'}
						disabled={(_columnChanged && _visibleColumns.length > 0) ? false : 'disabled'}
						className={`v3-button primary`}
						onClick={() => {
							const { onOk } = this.props;
							const { _visibleColumns } = this.state;
							if (typeof(onOk))
								onOk(_visibleColumns || []);
						}}>
						<FormattedMessage id='save' defaultMessage='Save' />
					</button>
				</div>
			</div>
		</Modal>
	}
}
export default injectIntl(CustomColumns);
